"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1652],{

/***/ 35998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile_tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.scss.js


var StyledMobileTabs = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bx2fs30"
})('*:focus{outline:none !important;}.carousel{.slick-slider.focus{.slick-list{.slick-track{padding:0;}}}}.mobile-tabs-navigation{overflow-x:auto;&::-webkit-scrollbar{display:none;}display:flex;gap:8px;padding-left:16px;.tab-nav-button-wrapper{display:flex;white-space:nowrap;}&::after{content:"";padding-right:16px;}}@media (min-width:', vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.carousel{.slick-slide{.side-by-side-text-and-asset{.side-by-side-content{.full-paragraph-component-wrapper{padding:0;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var VISIBILITY_SENSOR_OFFSET = -100;
var CAROUSEL_LEFT_SWIPE = "left";
var CAROUSEL_RIGHT_SWIPE = "right";
var MobileTabs = function(props) {
    var ref = (0,react.useState)(null), carouselRef = ref[0], setCarouselRef = ref[1];
    var ref1 = (0,react.useState)(false), isVisible = ref1[0], setIsVisible = ref1[1];
    var itemsRef = (0,react.useRef)([]);
    var tabs = props.tabs, selectedTab = props.selectedTab, setSelectedTab = props.setSelectedTab, navigationItemRenderer = props.navigationItemRenderer, carouselItemRenderer = props.carouselItemRenderer, wasComponentEverVisible = props.wasComponentEverVisible, setWasComponentEverVisible = props.setWasComponentEverVisible;
    var onVisibilityChange = function(isVisibleValue) {
        if (!wasComponentEverVisible && isVisibleValue) {
            setWasComponentEverVisible(true);
            if (selectedTab !== 0) {
                var _itemsRef_current_selectedTab, _itemsRef_current;
                itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_selectedTab = _itemsRef_current[selectedTab]) === null || _itemsRef_current_selectedTab === void 0 ? void 0 : _itemsRef_current_selectedTab.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center"
                });
            }
        }
        setIsVisible(isVisibleValue);
    };
    var tabsWithVideoPlayerRefs = [];
    tabs.forEach(function(tab) {
        tabsWithVideoPlayerRefs.push(_object_spread_props(_object_spread({}, tab), {
            videoPlayerRef: (0,react.useRef)(null)
        }));
    });
    (0,react.useEffect)(function() {
        itemsRef.current = itemsRef.current.slice(0, tabsWithVideoPlayerRefs.length);
    }, [
        tabsWithVideoPlayerRefs
    ]);
    var onTabClicked = function(element, tab, index) {
        setSelectedTab(index);
        element.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
        });
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAB_CLICKED, {
            kind: tab.tabLabel,
            info1: index
        });
    };
    (0,react.useEffect)(function() {
        var _currentTab_videoPlayerRef;
        var currentTab = tabsWithVideoPlayerRefs[selectedTab];
        if (currentTab === null || currentTab === void 0 ? void 0 : (_currentTab_videoPlayerRef = currentTab.videoPlayerRef) === null || _currentTab_videoPlayerRef === void 0 ? void 0 : _currentTab_videoPlayerRef.current) {
            currentTab.videoPlayerRef.current.seekTo(0);
        }
        carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.slickGoTo(selectedTab);
    }, [
        selectedTab
    ]);
    var scrollToNavigationTabIfVisible = function(index) {
        if (isVisible) {
            var _itemsRef_current_index, _itemsRef_current;
            itemsRef === null || itemsRef === void 0 ? void 0 : (_itemsRef_current = itemsRef.current) === null || _itemsRef_current === void 0 ? void 0 : (_itemsRef_current_index = _itemsRef_current[index]) === null || _itemsRef_current_index === void 0 ? void 0 : _itemsRef_current_index.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    var navItemRenderer = function(tab, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-nav-button-wrapper",
            ref: function(element) {
                return itemsRef.current[index] = element;
            },
            onClick: function(event) {
                return onTabClicked(event.target, tab, index);
            },
            children: navigationItemRenderer(tab, index)
        });
    };
    var carouselProps = {
        items: tabsWithVideoPlayerRefs,
        itemRenderer: carouselItemRenderer,
        defaultIndex: wasComponentEverVisible ? 0 : selectedTab,
        slidesToShow: 1,
        autoplay: false,
        autoplaySpeed: -1,
        centerPadding: "5%",
        centerMode: false,
        infinite: false,
        fade: false,
        onRefSet: setCarouselRef
    };
    var onCarouselChange = function(current) {
        // fix selectedTab index in case of a glitch
        if (current !== selectedTab) {
            setSelectedTab(current);
            scrollToNavigationTabIfVisible(current);
        }
    };
    var onCarouselSwipe = function(direction) {
        var newSlide = selectedTab;
        if (direction === CAROUSEL_LEFT_SWIPE && selectedTab < tabs.length - 1) {
            newSlide = selectedTab + 1;
        }
        if (direction === CAROUSEL_RIGHT_SWIPE && selectedTab > 0) {
            newSlide = selectedTab - 1;
        }
        setSelectedTab(newSlide);
        scrollToNavigationTabIfVisible(selectedTab);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileTabs, {
            className: "mobile-tabs-component",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-tabs-navigation",
                    children: tabsWithVideoPlayerRefs.map(function(tab, index) {
                        return navItemRenderer(tab, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "carousel-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, _object_spread_props(_object_spread({}, carouselProps), {
                        onChange: function(current) {
                            return onCarouselChange(current);
                        },
                        onSwipe: onCarouselSwipe
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_tabs = (MobileTabs);


/***/ }),

/***/ 11652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_board_views_component_tabs_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/default-props.js
var default_props = __webpack_require__(2536);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var theme = default_props/* default.theme */.Z.theme, boardViewTabsDefaultWithNoThemeProps = _object_without_properties(default_props/* default */.Z, [
    "theme"
]);
/* harmony default export */ var side_by_side_board_views_component_tabs_default_props = (_object_spread_props(_object_spread({}, boardViewTabsDefaultWithNoThemeProps), {
    fullParagraph: {
        topic: {},
        title: "<b>Many ways to grasp</b><br>your work",
        body: "Transform the way you see and manage your work with Views—a simple yet powerful feature to help you move from idea to execution, faster."
    }
}));

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./segments/desktop/core-components/mobile-tabs/mobile-tabs.js + 1 modules
var mobile_tabs = __webpack_require__(35998);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-mobile-component/side-by-side-board-views-component-tabs-mobile-component.scss.js



var StyledSideBySideBoardViewsComponentTabsMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1n1gc9k0"
})('.mobile-tabs-component{.mobile-tabs-navigation{gap:16px;.tab-nav-board-views-button{&:after{content:"";height:2px;width:100%;border-top-left-radius:4px;border-top-right-radius:4px;background-color:transparent;display:flex;transition:background-color 0.15s ease-in-out;}}.tab-nav-board-views-button.selected{&:after{background-color:', colors/* default */.Z[color_consts.WORK_OS_IRIS_COLOR_NAME], ";}}.title-and-icon-wrapper{padding:0 4px;.icon-wrapper{margin-top:4px;margin-right:4px;align-items:center;.picture-icon-wrapper.picture-component{width:18px;height:18px;margin-bottom:0;}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-mobile-component/side-by-side-board-views-component-tabs-mobile-component.js
function side_by_side_board_views_component_tabs_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}








var SideBySideBoardViewsComponentTabsMobileComponent = function(props) {
    var ref = (0,react.useState)(0), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)(false), wasComponentEverVisible = ref1[0], setWasComponentEverVisible = ref1[1];
    var tabs = props.tabs;
    var navigationItemRenderer = function(tab, index) {
        var tabLabel = tab.tabLabel, tabId = tab.tabId, image = tab.image;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("tab-nav-board-views-button", {
                selected: selectedTab === index
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                title: tabLabel,
                titleIcon: image === null || image === void 0 ? void 0 : image.src,
                titleSize: sizes/* XS_M */.g4
            })
        });
    };
    var carouselItemRenderer = function(tab) {
        var asset = tab.asset;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "asset-and-paragraphs-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, side_by_side_board_views_component_tabs_mobile_component_object_spread({}, asset))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideBoardViewsComponentTabsMobileComponent, {
        className: "use-cases-tabs-mobile-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_tabs/* default */.Z, {
            tabs: tabs,
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        })
    });
};
/* harmony default export */ var side_by_side_board_views_component_tabs_mobile_component = (SideBySideBoardViewsComponentTabsMobileComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.js + 1 modules
var board_views_tab = __webpack_require__(20959);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-desktop-component/side-by-side-board-views-component-tabs-desktop-component.scss.js


var StyledSideBySideBoardViewsComponentTabsDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1aeruyh0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;flex-direction:row;.full-paragraph-wrapper{width:45%;padding:45px 150px 50px 30px;}.board-views-tab-wrapper{width:55%;padding-right:20px;}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-desktop-component/side-by-side-board-views-component-tabs-desktop-component.js
function side_by_side_board_views_component_tabs_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideBoardViewsComponentTabsDesktopComponent = function(props) {
    var fullParagraph = props.fullParagraph, theme = props.theme, tabs = props.tabs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideBoardViewsComponentTabsDesktopComponent, {
        className: "side-by-side-board-views-component-tabs-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "full-paragraph-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_board_views_component_tabs_desktop_component_object_spread({}, fullParagraph))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "board-views-tab-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(board_views_tab/* default */.Z, {
                    theme: theme,
                    tabs: tabs
                })
            })
        ]
    });
};
/* harmony default export */ var side_by_side_board_views_component_tabs_desktop_component = (SideBySideBoardViewsComponentTabsDesktopComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-component.js




var SideBySideBoardViewsComponentTabsComponent = (0,responsive_hoc_component/* default */.Z)(side_by_side_board_views_component_tabs_desktop_component, side_by_side_board_views_component_tabs_mobile_component);
SideBySideBoardViewsComponentTabsComponent.defaultProps = side_by_side_board_views_component_tabs_default_props;
/* harmony default export */ var side_by_side_board_views_component_tabs_component = (SideBySideBoardViewsComponentTabsComponent);


/***/ })

}]);